import Seller from './seller';

export default Seller;
